import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { fetchSettings } from "../../redux/userSetting";
import JournalEntryModal from "../../components/accounting/JournalEntryModal";
import { fetchledger } from "../../redux/ledger";
import { getJournal, deleteJournal } from "../../services/AccountApiServices";
import { Journalentry } from "../../core/json/JournalEntry";
import { TransactionScreen } from "../../components/transactions/list";
import { dateOf, dmy, intg, money, num } from "../../components/report/reportFormat";

const JournalEntry = () => {
  const [journalEntry, setJournalEntry] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const { menuItems } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const { formatedLedger } = useSelector((state) => state.ledger);
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Journal")
    );
    dispatch(fetchledger());
  }, []);
  useEffect(() => {
    dispatch(fetchledger());
    dispatch(fetchSettings(branch));
    handleJournalEntry();
    // handleFilter();
  }, [branch]);

  const handleJournalEntry = async () => {
    try {
      const response = await getJournal(branch);
      const invoice = Array.isArray(response.data) ? response.data : [];
      const filterInvoiceByBranch = invoice.filter(
        (invoice) => invoice?.branch?.guid === branch?.guid
      );
      setJournalEntry(filterInvoiceByBranch);
    } catch (error) {
      console.error(
        "Failed to fetch journal entry",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEditClick = async (guid) => {
    try {
      const response = journalEntry?.find((sales) => sales.guid === guid);
      setUpdateData(response);

      setModalMode("edit");
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error fetching sales invoice by GUID",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleDeleteClick = (obj) => {
    const objpayment = new Journalentry();
    objpayment.branch = branch;
    objpayment.guid = obj.guid;
    objpayment.id = obj.id;
    objpayment.updatedUser = userId?.id;
    objpayment.createdUser = userId?.id;
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteJournal(objpayment);
          if (response.data === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The journal has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handleJournalEntry();
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting sales quotation:", error);
          MySwal.fire({
            title: "Error!",
            text: error?.response?.data?.Message || "something went wrong",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  /* ---------------- list ---------------- */
  const ledgerName = (id) =>
    formatedLedger?.find((e) => e.value == id)?.label || "";

  // one flat record per journal entry; the keys match the column definitions
  const rows = useMemo(
    () =>
      journalEntry.map((r) => {
        const lines = r.journalDetails || [];
        const debit = lines.reduce((a, l) => a + num(l?.debit), 0);
        const credit = lines.reduce((a, l) => a + num(l?.credit), 0);
        return {
          guid: r.guid,
          raw: r,
          date: dateOf(r.date),
          billNo: r.no != null ? String(r.no) : "",
          narration: r.narration || "",
          items: lines.length,
          debit,
          credit,
          net: debit,
          lines,
        };
      }),
    [journalEntry]
  );

  const columns = useMemo(
    () => [
      { k: "date", t: "Date", type: "date", ago: true },
      { k: "billNo", t: "Entry", type: "doc" },
      { k: "narration", t: "Remarks" },
      { k: "items", t: "Lines", type: "int", off: true },
      { k: "credit", t: "Credit", type: "money", off: true },
      { k: "net", t: "Amount", type: "money" },
    ],
    []
  );

  const tabs = useMemo(() => [{ id: "all", label: "Journal Entry" }], []);

  const filters = useMemo(
    () => [
      {
        key: "ledger",
        label: "Ledger",
        items: (formatedLedger || []).map((l) => ({ v: l.value, t: l.label || "—" })),
        match: (r, v) => r.lines.some((l) => v.includes(l?.ledgerID)),
      },
    ],
    [formatedLedger]
  );

  const searchMatch = (r, q) => {
    const hit = (s) => String(s || "").toLowerCase().includes(q);
    return (
      hit(r.billNo) ||
      hit(r.narration) ||
      hit(r.date) ||
      String(r.net).includes(q) ||
      r.lines.some(
        (l) =>
          hit(ledgerName(l?.ledgerID)) ||
          hit(l?.narration) ||
          String(l?.debit ?? "").includes(q) ||
          String(l?.credit ?? "").includes(q)
      )
    );
  };

  const drawerContent = (r) => ({
    title: r.narration || `Journal ${r.billNo}`,
    subtitle: [`Journal ${r.billNo}`, dmy(r.date)].filter(Boolean).join("  ·  "),
    avatarKey: r.narration || r.billNo,
    meta: [
      { k: "Remarks", v: r.narration },
      { k: "Lines", v: intg(r.items) },
      { k: "Total debit", v: money(r.debit) },
      { k: "Total credit", v: money(r.credit) },
    ],
    lines: {
      title: "Journal lines",
      columns: [
        { t: "Ledger" },
        { t: "Narration" },
        { t: "Debit", align: "right" },
        { t: "Credit", align: "right" },
      ],
      rows: r.lines.map((l) => [
        <div key="nm" className="axr-nm">{ledgerName(l?.ledgerID) || "Unknown ledger"}</div>,
        l?.narration || "—",
        money(l?.debit),
        money(l?.credit),
      ]),
    },
    net: { l: "Total", v: money(r.net) },
  });

  return (
    <TransactionScreen
      title="Journal Entry"
      subtitle="Manage journal entry here"
      unit="entries"
      rows={rows}
      columns={columns}
      tabs={tabs}
      filters={filters}
      searchMatch={searchMatch}
      searchPlaceholder="Entry no, remarks, ledger, amount…"
      sortOptions={[
        { v: "date:-1", t: "Newest first" },
        { v: "date:1", t: "Oldest first" },
        { v: "net:-1", t: "Largest amount" },
        { v: "net:1", t: "Smallest amount" },
      ]}
      exportName="Journal Entry"
      onRefresh={handleJournalEntry}
      canAdd={true /* the old page had its permit?.add check commented out */}
      newLabel="New journal"
      onNew={() => {
        setModalMode("add"); // Set the modal mode to 'add'
        setModalOpen(true); // Open the modal
      }}
      canEdit={permit?.edit}
      onEdit={(r) => handleEditClick(r.guid)}
      editLabel="Edit journal"
      canDelete={permit?.deletion}
      onDelete={(r) => handleDeleteClick(r.raw)}
      drawerContent={drawerContent}
      keysDisabled={modalOpen}
    >
      {/* Reason Modal */}
      {modalOpen && (
        <JournalEntryModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handleJournalEntry();
          }}
        />
      )}
    </TransactionScreen>
  );
};

export default JournalEntry;
